import React from "react";
import classes from "./andRulesAndSubmit.module.css";

const ANDRulesAndSubmit = () => {
  return (
    <div className={classes.container}>
      <header>
        <p>
          Here's your time to shine. Get a chance to be elected as a winner on
          the AND Stage
        </p>
        <button className={classes.backButton}>Go back</button>
      </header>

      <main>
        <section className={classes.rules}>
          <h1>
            <span>Rules</span> for artists competing this week
          </h1>
          <ol>
            <li>
              <strong>No Lip-Syncing</strong> – Live or pre-recorded vocals
              only, no miming! Backing Tracks Allowed – But the main vocals must
              be yours.
            </li>
            <li>
              <strong>Originality Matters</strong> – Your performance must be
              original or have a unique spin on existing work. Plagiarism will
              result in disqualification.
            </li>
            <li>
              <strong>Respect the Stage</strong> – No offensive, discriminatory,
              or inappropriate content. Keep it classy, keep it creative.
            </li>
            <li>
              <strong>Time Limit</strong> – Each performance must be within the
              allocated time (e.g., 2–5 minutes).
            </li>
            <li>
              <strong>Shot, One Chance</strong> – Once submitted, no
              re-uploading or modifications. Perform your best!
            </li>
          </ol>
        </section>

        <section className={classes.buttonsSection}>
          <button className={classes.submitButton}>
            <div className={`${classes.buttonIcon} ${classes.upArrow}`}></div>
            <span>Submit my Performance</span>
          </button>

          <button className={classes.tipsButton}>
            <div className={`${classes.buttonIcon} ${classes.lightbulb}`}></div>
            <span>Performance Tips</span>
          </button>

          <div className={classes.subButtons}>
            <button className={classes.tellUsButton}>
              <span>Tell us something about your performance.</span>
            </button>

            <button className={classes.uploadButton}>
              <span>Upload for Review</span>
            </button>
          </div>
        </section>
      </main>
    </div>
  );
};

export default ANDRulesAndSubmit;
